import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toastmodal from "../Toastmodal";
import { useAuthHandling } from '../useAuthhandling';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Allimagestyle from "./Allimage_style";
import Allimageselect from "./Allimageselect";


function Blogedit() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);

  const [selectedImageId, setSelectedImageId] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);


  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [blog, setBlog] = useState([]);
  const [description,setDescription]=useState([]);

  const [date, setDate] = useState("");
  const [formerror, setError] = useState({});
  const [formerror1, setError1] = useState({});

  let { id } = useParams();
  let name, value;

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/blog/get-blog/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200 ) {
      const data = await res.json();

      setBlog(data.data);
      setDescription(data.data.description);
      setDate(moment(data.data.publishDate).utc().format("YYYY-MM-DD"));

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  const handleInput = (e) => {
    console.log(e);
    value = e.target.value;

    setDate(value);
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setDescription(data);
  };

  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setBlog({ ...blog, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setBlog({ ...blog, [name]: e.target.files[0] });
  };
  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Title is required!";
    }

    if (!values.description) {
      errors.description = "Description is required!";
    }
    if (!values.slug) {
      errors.slug = "Slug is required!";
    }
    if (!values.metaTitle) {
      errors.metaTitle= "Meta title is required!";
    }
    if (!values.metaDescription) {
      errors.metaDescription = "Meta description is required!";
    }
    if (selectedImageId.length===0) {
      if (values.blogImage.length===0) {
        errors.blogImage = "Image is required!";
      } 
    
    } 
    // else if (values.blogImage.type) {
    //   if (
    //     values.blogImage.type === "image/jpeg" ||
    //     values.blogImage.type === "image/jpg" ||
    //     values.blogImage.type === "image/png"
    //   ) {
    //     if (values.blogImage.size > 1024 * 1000) {
    //       errors.blogImage =
    //         "maximum file size 1 mb...please upload an image less than 1 mb";
    //     }
    //   } else {
    //     errors.blogImage = "Only support jpg, jpeg, png image!";
    //   }
    // }

    return errors;
  };

  const validatedes = (values) => {
    const errors = {};
    if (!values) {
      errors.description = "Description is required!";

    }
    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { title, slug, blogImage } = blog;
    const ress = validate(blog);
    const ressdes = validatedes(description);

    setError(ress);
    setError1(ressdes);

    if (!ress.title && !ressdes.description && !ress.slug && !ress.blogImage && !ress.metaTitle && !ress.metaDescription) {
      // const formData = new FormData();
      // formData.append("title", blog.title);
      // formData.append("description", description);
      // formData.append("blogImg", blog.blogImage);
      // formData.append("slug", blog.slug);
      // formData.append("status", blog.status);
      // formData.append("metaTitle", blog.metaTitle);
      // formData.append("metaDescription", blog.metaDescription);
      // formData.append("publishDate", date);

      const data = {
        title: blog.title,
        description: description,
        blog_images: selectedImageId.map((img) => img.id),
        slug: blog.slug,
        status:blog.status,
        draft:blog?.draft,
        metaTitle:blog.metatitle,
        metaDescription: blog.metadescription,
        publishDate:date
      };
      axios
        .put(`${Config.apiurl}/api/v1/crm/blog/update-blog/${id}`, data, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            setToastmodal(true);
            setToastmessage("Sucessfully Updated");
            setToasttype("success");
            setToastlarge(false);
            setTimeout(() => navigate("/dashboard"), 3000);
          
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            setToastmodal(true);
            setToastmessage(res.message);
            setToasttype("error");
            setToastlarge(true);
           
          }
        });
    }
  };

  useEffect(() => {
    getinfo();
  }, []);

  return (
    <>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row grid-margin">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Blog Table</h4>
                      <p className="card-description">Edit Blog</p>
                      <form className="forms-sample" onSubmit={PostData}>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Title"
                            name="title"
                            value={blog.title}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.title}
                          </label>
                        </div>
                        <div className="form-group ck_edit_cls">
                          <label htmlFor="exampleInputUsername1">
                            Description
                          </label>
                          {/* <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Description"
                            name="description"
                            value={blog.description}
                            onChange={handleInputs}
                          /> */}

<CKEditor
                    editor={ ClassicEditor }    
                    data={description}
                    onChange={handleEditorChange}               
                  
                />       
                          <label style={{ color: "red" }}>
                            {formerror1.description}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Slug</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Slug"
                            name="slug"
                            value={blog.slug}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.slug}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                            PublishDate
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="PublishDate"
                            name="publishDate"
                            value={date}
                            onChange={handleInput}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">Meta Title</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Meta title"
                            name="metaTitle"
                            value={blog.metaTitle}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.metaTitle}
                          </label>
                        </div>
                        <div className="form-group">
                          <label htmlFor="exampleInputUsername1">
                           Meta Descriptiom
                          </label>
                          <textarea
                            rows="5"
                            className="form-control"
                            id="exampleInputUsername1"
                            placeholder="Meta description"
                            name="metaDescription"
                            value={blog.metaDescription}
                            onChange={handleInputs}
                          />
                          <label style={{ color: "red" }}>
                            {formerror.metaDescription}
                          </label>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Status
                              </label>

                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="status"
                                onChange={handleInputs}
                                value={blog.status}
                              >
                                <option
                                value={true}
                                  {...(blog.status === true ? "selected" : "")}
                                >
                                 Active
                                </option>
                                <option
                                value={false}
                                  {...(blog.status === false ? "selected" : "")}
                                >
                                  In Active
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="exampleInputUsername1">
                                Draft/Publish
                              </label>

                              <select
                                className="form-control "
                                style={{
                                  color: "black",
                                  backgroundColor: "#2b2e4c;",
                                }}
                                id="exampleInputUsername1"
                                name="draft"
                                onChange={handleInputs}
                                value={blog.draft}
                              >
                                <option
                                value={true}
                                  {...(blog.draft === true ? "selected" : "")}
                                >
                                  Draft
                                </option>
                                <option
                                value={false}
                                  {...(blog.draft === false ? "selected" : "")}
                                >
                                  Publish
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">
                            Image (400px * 340px)
                          </label>
                          <br></br>
                          {/* <input
                            type="file"
                            name="blogImage"
                            onChange={onFileChange}
                          /> */}
                         <Allimagestyle selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>

                          <div className="d-flex">
                            {blog?.blogImage?.length !== 0
                              ? blog?.blogImage?.map((elements, index) => {
                                  return (
                                    <div key={index}  className="position-relative col-md-2"
                                    style={{
                                      width: "107px",
                                      height: "100px",
                                      marginTop: "5px",
                                      //  marginRight: "5px",
                                    }}
                                    >
                                      <img
                                        src={elements.imageFile}
                                        alt=""
                                      
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          marginTop: "5px",
                                          marginLeft: "5px",
                                        }}
                                      />

                                    
                                    </div>
                                  );
                                })
                              : ""} 
                          
                          </div>
                        </div>

                        <Allimageselect selectedImageId={selectedImageId} setSelectedImageId ={setSelectedImageId}  uploadedImages={uploadedImages} setUploadedImages={setUploadedImages}/>
                      
                      <label style={{ color: "red" }}>
                          {formerror.image}
                        </label>
                        <br></br>

                        <button
                          type="submit"
                          style={{ marginTop:"10px"}}
                          onClick={PostData}
                          className="btn btn-primary me-2"
                        >
                          Submit
                        </button>
                        <ToastContainer />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Blogedit;
